//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AQEmptyState from "@/components/Generics/AQEmptyState/AQEmptyState.vue";
import AQList from "@/components/Generics/AQList/AQList.vue";
import { mapActions } from "vuex";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import AQSearch from "@/components/Generics/AQSearch/AQSearch.vue";
import AQEmptySearch from "@/components/Generics/AQEmptySearch/AQEmptySearch.vue";
import AQSkeleton from "@/components/Generics/AQSkeleton/AQSkeleton.vue";
import ImportPluginDialog from "./dialog-import-plugin.vue";

export default {
    name: "Plugins",
    components: {
        AQEmptyState,
        ImportPluginDialog,
        AQList,
        AQButton,
        AQSearch,
        AQEmptySearch,
        AQSkeleton
    },
    data() {
        return {
            loading: true,
            resetSearchData: false,
            plugins: [],
            filteredPlugins: [],
            showUpload: false,
            searchPlugins: "",
            searchTrigger: false
        };
    },
    computed: {
        propsForAvatar() {
            return {
                disabled: "active",
                type: "plugin",
                defaultAvatar: "plugin"
            };
        },
        badgeType() {
            return {
                badgeText: "status"
            };
        }
    },
    watch: {
        showSearch: {
            handler(newVal) {
                this.searchTrigger = newVal;
                setTimeout(() => {
                    this.searchTrigger = false;
                }, 0);
            },
            immediate: true
        }
    },
    created() {
        this.getPluginList();
    },
    activated() {
        this.resetSearchData = false;
        const { query } = this.$route;
        if (query && Object.keys(query).length && query.search) {
            this.$nextTick(() => {
                this.searchTrigger = true;
                this.searchPlugins = query.search;
            });
        }
    },
    deactivated() {
        this.searchPlugins = "";
    },
    methods: {
        ...mapActions("admin", ["actPluginList"]),
        getPluginList(resetSearch) {
            this.actPluginList().then(
                response => {
                    const { data } = response || {};

                    this.filteredPlugins = (data || []).map(plugin => {
                        const { active, description } = plugin;
                        const extraProps = {
                            email: description,
                            status: active ? "Active" : "Inactive",
                            customColor: `var(--q-color-${active ? "chip-green-text" : "dark"})`,
                            customBackground: active ? "var(--q-color-chip-green-background)" : ""
                        };
                        return { ...plugin, ...extraProps };
                    });
                    this.plugins = this.filteredPlugins;
                    const { query } = this.$route;
                    if (query && Object.keys(query).length && query.search) {
                        this.searchItems(query.search);
                    } else if (resetSearch) {
                        this.resetSearchData = true;
                        setTimeout(() => {
                            this.resetSearchData = false;
                        }, 0);
                    }
                    this.loading = false;
                }
            )
                .catch(() => {
                    this.loading = false;
                });
        },
        searchItems(data) {
            const searchValue = data.trim();
            if (searchValue) {
                this.filteredPlugins = this.plugins.filter(({ name }) => name.toLowerCase().includes(searchValue.toLowerCase()));
                this.searchPlugins = searchValue;
                const queriesAreDifferent = JSON.stringify({ search: this.searchPlugins }) !== JSON.stringify(this.$route.query);
                if (queriesAreDifferent) {
                    this.$router.replace({ query: { search: this.searchPlugins } });
                }
            } else if (this.$route.query && Object.keys(this.$route.query).length > 0 && this.$route.name === "Plugins") {
                this.$router.replace({});
                this.filteredPlugins = this.plugins;
            }
        }
    }
};
